import { PageController } from '@client/components/_core/layout/PageController';
import { CommunicationSignatureEdit } from '@client/components/communication-templates/CommunicationSignatureEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/org-settings/communication/comm-signatures/edit/$commSignatureId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit communication signature',
        },
    },
    params: {
        parse({ commSignatureId }) {
            return {
                commSignatureId: BigInt(commSignatureId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <CommunicationSignatureEdit action={['edit', Route.useParams().commSignatureId]} />
        </PageController>
    );
}
